import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Modal } from 'antd';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import DateInput from "components/Form/dateInput";
import { useDropzone } from 'react-dropzone';
import useUploadHook from "components/uploadHook";
import Attachment from "components/Attachments/attachmentListEdit";
import { Button } from "components/Button";
import EssFullWidthModal from "components/modelpopup/baseModal";
import { format } from "date-fns";
const ReturnAssetModal = (props) => {
  const [loading, setLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);

  // Schema for form validation
  const returnAssetSchema = Yup.object().shape({
    return_date: Yup.date().required('Return date is required'),
    comment: Yup.string(),
    attachments: Yup.array()
  });

  // Setup form handling with react-hook-form
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    register,
    watch,
  } = useForm({
    resolver: yupResolver(returnAssetSchema),
    defaultValues: {
      attachments: []
    }
  });

  // Use upload hook for handling file uploads
  const {
    uploadLoading: fileUploadLoading,
    handleFile
  } = useUploadHook();

  // File upload handler
  const fileUploadHandler = async(acceptedFiles, rejectedFiles, e) => {
    let attachments = [];
    const urls = await handleFile(e);
    if(Array.isArray(urls)){
      attachments = urls.map(item => { return { url: item } });
    } else {
      attachments.push({
        url: urls
      });
    }
    
    const currentAttachments = watch("attachments") || [];
    setValue("attachments", [...currentAttachments, ...attachments]);
  };

  // Setup dropzone for file uploads
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: fileUploadHandler,
    accept: 'image/*'
  });

  // Form submission handler
  const onSubmit = (formData) => {
    setLoading(true);
    // Include form data with the existing handler
    if(formData.return_date){
      formData['return_date'] = format(new Date(formData.return_date), "yyyy-MM-dd")
    }
    let attachments_data = formData.attachments?.map(item=>{
      return{
        id: item.item_id||"",
        url: item.url
      }
    })
    formData['attachments'] = attachments_data||[]

    const returnData = {
      ...formData,
      // Add any additional processing needed
    };
    
    // Call the existing handler with the enhanced data
    props.returnAssetHandler(returnData);
    closeModal()
  };

  const closeModal = () => {
    props.setReturnAssetModal(false);
    setLoading(false);
    setValue("attachments", []);
    setValue("return_date", "");
    setValue("comment", "");
    
  }
  return (
    <>
      <EssFullWidthModal
        style={{ top: 100 }}
        open={props.returnAssetModal}
        width={"40%"}
        footer={[]}
        onCancel={() => {
          closeModal()
        }}


        mask={false}
        title={"Return Asset"}
        // style={{ top: 100 }}
          
        
          className="full-width-modal"

      >
        <div className="modal-content">
          <div className="modal-body">
            {/* <div className="form-header">
              <h3>{props.Name}</h3>
              <p>Please provide details for returning the asset</p>
            </div> */}

            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className="input-block mb-3 col-sm-12 col-md-6">
                  <label className="col-form-label">
                    Return Date <span className="text-danger">*</span>
                  </label>
                  <Controller
                    name="return_date"
                    control={control}
                    render={({ field }) => (
                      <DateInput
                        className="form-control floating datetimepicker"
                        selected={field?.value}
                        onChange={(date) => field.onChange(date)}
                        dateFormat="dd-MM-yyyy"
                      />
                    )}
                  />
                  {errors.return_date && (
                    <small className="text-danger">
                      {errors.return_date?.message}
                    </small>
                  )}
                </div>

                <div className="input-block mb-3 col-sm-12 col-md-6">
                  <label className="col-form-label">
                    Comments
                  </label>
                  <textarea
                    {...register("comment")}
                    rows={4}
                    className="form-control"
                  />
                </div>

                <div className="input-block mb-3 col-sm-12 col-md-6">
                  <label className="col-form-label">
                    Attachments {fileUploadLoading && <i className="fa fa-spinner fa-spin"></i>}
                  </label>
                  <div
                    {...getRootProps({ className: 'dropzone' })}
                    style={{
                      border: '2px dashed #000',
                      padding: '20px',
                      textAlign: 'center',
                    }}
                  >
                    <input {...getInputProps()} />
                    <p>Drag & Drop your files here, or click to select files</p>
                  </div>
                </div>

                <div className="col-12">
                  <Attachment fields={watch("attachments") || []} remove={(index) => {
                    const currentAttachments = [...watch("attachments")];
                    currentAttachments.splice(index, 1);
                    setValue("attachments", currentAttachments);
                  }} />
                </div>
              </div>

                
                <div className="submit-section">
                <Button
                  loading={loading}
                  disabled={loading || fileUploadLoading}
                    className="btn btn-primary submit-btn"             
                    type="submit"
                    label="Return Asset"
                  />
                </div>

            </form>
          </div>
        </div>
      </EssFullWidthModal>
    </>
  );
};

export default ReturnAssetModal;
